import SearchModuleDestination from './SearchModuleDestination';

export default SearchModuleDestination;
